define('common/views/loading_view',['require','exports','module','base/view','ldsh!../templates/loading_view'],function(require, exports, module){
  "use strict";
  var View = require("base/view");
  module.exports = View.extend({
    template: require("ldsh!../templates/loading_view"),
    onRender: function(){
      this.$el.i18n();
    }
  });
});
